import { motion } from 'framer-motion';
import { MessageSquare, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LanguageSwitcher } from './LanguageSwitcher';
import { Language } from '../i18n/translations';

interface NavbarProps {
  t: any;
  currentLang: Language;
  setLanguage: (lang: Language) => void;
}

export function Navbar({ t, currentLang, setLanguage }: NavbarProps) {
  return (
    <motion.nav 
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-zinc-950/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500/10">
            <MessageSquare className="h-5 w-5 text-emerald-500" />
          </div>
          <span className="text-lg font-bold tracking-tight text-white">Totemium</span>
        </div>

        <div className="hidden items-center gap-8 md:flex">
          <a href="#features" className="text-sm font-medium text-zinc-400 hover:text-white transition-colors">{t.navbar.features}</a>
          <a href="#pricing" className="text-sm font-medium text-zinc-400 hover:text-white transition-colors">{t.navbar.pricing}</a>
          <a href="#faq" className="text-sm font-medium text-zinc-400 hover:text-white transition-colors">{t.navbar.faq}</a>
        </div>

        <div className="flex items-center gap-4">
          <LanguageSwitcher currentLang={currentLang} onChange={setLanguage} />
          
          <Link 
            to="/login" 
            className="hidden text-sm font-medium text-zinc-400 hover:text-white transition-colors sm:block"
          >
            {t.navbar.login}
          </Link>
          <Link
            to="/register"
            className="group relative hidden sm:flex items-center gap-2 rounded-full bg-emerald-500 px-4 py-2 text-sm font-semibold text-white transition-all hover:bg-emerald-400 hover:shadow-[0_0_20px_-5px_rgba(16,185,129,0.5)]"
          >
            {t.navbar.cta}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </div>
      </div>
    </motion.nav>
  );
}
